import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { GetRecipeResponseDTO } from './recipe.dto';

@Injectable({ providedIn: 'root' })
export class RecipeService {
  constructor(private http: HttpClient) { }

  getFeaturedRecipe(userId: number) {
    const url = environment.apiUrl + '/api/recipe/featured/' + userId;
    return this.http.get<GetRecipeResponseDTO>(url);
  }

  getRecipeById(recipeId: number, userId: number) {
    const url =
      environment.apiUrl + '/api/recipe/recipes/' + recipeId + '/' + userId;
    return this.http.get<GetRecipeResponseDTO>(url);
  }

  getAllRecipes() {
    const url = environment.apiUrl + '/api/recipe/allrecipes/';
    return this.http.get<GetRecipeResponseDTO[]>(url);
  }
  getFavRecipes(userId: number) {
    const url = environment.apiUrl + '/api/recipe/favlist/' + userId;
    return this.http.get<GetRecipeResponseDTO[]>(url);
  }

  AddToFavorites(recipeId: number, userId: number) {
    const url =
      environment.apiUrl + '/api/recipe/fav/' + recipeId + '/' + userId;
    return this.http.post<boolean>(url, {});
  }
  RemoveFromFavorites(recipeId: number, userId: number) {
    const url =
      environment.apiUrl + '/api/recipe/unfav/' + recipeId + '/' + userId;
    return this.http.delete<boolean>(url, {});
  }
}
